module.exports = __webpack_public_path__ + "img/1496aeb.jpg";